export const observeProperty = ({ propertyTargetStr }: { propertyTargetStr: string }) => {
  if (typeof propertyTargetStr !== 'string') {
    throw new Error('observeValue: Accept parameter only type string that return value do you want know them appear.')
  }

  return new Promise((resolve, reject) => {
    const startTimeObserve = +new Date()
    const observeInterval = setInterval(function () {
      const propertyTarget = eval(propertyTargetStr)

      // If find target resolve true and clearInterval
      if (propertyTarget) {
        clearInterval(observeInterval)
        resolve(true)
      }

      // If over 10 second to call reject for timeout
      const currentTime = +new Date()
      if (currentTime - startTimeObserve >= 10000) {
        reject('Timeout to find property ovef 10 second.')
      }
    }, 100)
  })
}

export const observeValue = (fn: () => any) => {
  if (typeof fn !== 'function') {
    throw new Error('observeValue: Accept parameter only type function that return value do you want know them appear.')
  }

  return new Promise((resolve, reject) => {
    const startTimeObserve = +new Date()
    const observeInterval = setInterval(function () {
      const propertyTarget = fn()

      // If find target resolve true and clearInterval
      if (propertyTarget) {
        clearInterval(observeInterval)
        resolve(true)
      }

      // If over 10 second to call reject for timeout
      const currentTime = +new Date()
      if (currentTime - startTimeObserve >= 10000) {
        reject('Timeout to find property ovef 10 second.')
      }
    }, 100)
  })
}
